import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/tailwind.css';
import { PlayerProvider } from './hooks/usePlayer';
import { ToastProvider } from './hooks/useToast';
import { registerServiceWorker } from './lib/sw-register';

registerServiceWorker();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <PlayerProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </PlayerProvider>
    </BrowserRouter>
  </React.StrictMode>
);
